import apiService from "./BaseApi";
import store from "@/store/index";

const ENDPOINT = "features";

const FeaturesService = {
  getFeatures: async () =>
    apiService.get(ENDPOINT, {
      params: {
        currentUserId: store.state.currentUser?.uid,
      },
    }),
};

export default FeaturesService;
